import useLockBodyScroll from "hooks/useLockBodyScroll"

function LockBodyScroll() {
  useLockBodyScroll()
  return null
}

export default LockBodyScroll
